// extracted by mini-css-extract-plugin
export var typingIndicator = "_n8-0";